module.exports = __webpack_public_path__ + "static/media/off.866b993b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/common/images/off.svg
// module id = 1583
// module chunks = 0